// MB-I18N-1 — Normalisation pure d'une valeur de locale (software uniquement).
// Ne retourne QUE des locales activées, sinon DEFAULT_LOCALE. Ne plante jamais.

import { DEFAULT_LOCALE, ENABLED_LOCALES } from './localesConfig';

export function resolveLocale(value) {
  if (value === null || value === undefined) return DEFAULT_LOCALE;

  const raw = String(value).trim().toLowerCase();
  if (!raw) return DEFAULT_LOCALE;

  // Normalise les séparateurs régionaux (fr_FR, fr-FR, en-US, en-GB…) vers la base.
  const base = raw.replace(/_/g, '-').split('-')[0];

  return ENABLED_LOCALES.includes(base) ? base : DEFAULT_LOCALE;
}
